import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../../../theme';

/**
 * Custom hook that defines the styles for the UserInfo component.
 */
const useUserInfoStyles = makeStyles()(() => ({
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.gap.m,
    padding: theme.padding.s,
    flexWrap: 'wrap',
  },
  avatar: {
    border: `1.5px solid ${colors.black}`,
  },
}));

export default useUserInfoStyles;
